import Moment from 'moment-timezone'
import tzlookup from 'tz-lookup'

const DEFAULT_REQ_PREFIX = "REQ_"
export default class Utils {
    static getCurrentUrlParams() {
        return this.getAllUrlParams(window.location.href);
    }

    static getValForKeyFromCurrentUrl(key) {
        var paramsDict = this.getCurrentUrlParams();
        var val = paramsDict[key]
        if (this.isNull(val)) {
            return val
        }
        return decodeURIComponent(val)
    }

    static getAllUrlParams(url) {
        let queryString = url ? url.split('?')[1] : window.location.search.slice(1);
        let obj = {};
        if (queryString) {
            queryString = queryString.split('#')[0];
            let arr = queryString.split('&');

            for (let i = 0; i < arr.length; i++) {
                let a = arr[i].split('=');
                if (this.isNull(a) === true || a.length !== 2) {
                    continue
                }
                let paramNum;
                let paramName = a[0].replace(/\[\d*\]/, v => {
                    paramNum = v.slice(1, -1);
                    return '';
                });
                let paramValue = this.isNull(a[1]) === true ? true : a[1];
                paramName = paramName.toLowerCase();
                paramValue = paramValue.toLowerCase();
                if (obj[paramName]) {
                    if (typeof obj[paramName] === 'string') {
                        obj[paramName] = [obj[paramName]];
                    }
                    if (typeof paramNum === 'undefined') {
                        obj[paramName].push(paramValue);
                    } else {
                        obj[paramName][paramNum] = paramValue;
                    }
                } else {
                    obj[paramName] = paramValue;
                }
            }
        }

        return obj;
    }

    static encodeObjectToUrlArgs(data) {
        if (this.isNull(data)) {
            return ""
        }

        var ret = [];
        for (let key in data) {
            ret.push(encodeURIComponent(key) + '=' + encodeURIComponent(data[key]));
        }
        return ret.join('&');
    }

    static isValidTimezone(timezone) {
        return (
            false === this.isNull(timezone) &&
            false === this.isNull(Moment.tz.zone(timezone))
        )
    }

    static getValidTimezoneFromLatLon(lat, lon) {
        if (this.isNull(lat) || this.isNull(lon)) {
            return null;
        }
        try {
            return tzlookup(lat, lon)
        } catch (error) {
            console.log("Tzlookup error - " + error)
        }
        return null;
    }

    static formatMillisIntoTimeStrForTimezone(timestampMillis, timezone, format) {
        if (this.isNull(Moment.tz.zone(timezone))) {
            console.log("Timezone is invalid - " + timezone)
            return ""
        }

        var moment = Moment.tz(timestampMillis, timezone)
        if (false === moment.isValid()) {
            return "";
        }
        return moment.format(format)
    }

    static formatIntoTimeStrForTimezone(timestamp, timezone, format) {
        return this.formatMillisIntoTimeStrForTimezone(timestamp * 1000, timezone, format)
    }

    static convertDecimalToPercentageString(val) {
        if (typeof (val) === "undefined" || val === null) {
            val = 0;
        } else if (typeof (val) === "string") {
            val = parseFloat(val)
            if (true === isNaN(val)) {
                val = 0;
            }
        }
        return '' + Math.round(val * 100)
    }

    static isNull(obj) {
        return (typeof (obj) === "undefined" || obj === null)
    }

    static isEmptyStr(obj) {
        return (this.isNull(obj) || (typeof obj === "string" && obj.trim() === ""));
    }

    static convertToNumber(num) {
        return isNaN(num) ? '' : Number(num)
    }

    static formatDisplayString(ipStr, shouldTitleCase, shouldReplaceNonSpaceSep, shouldReplaceHyphen) {
        // Default the options entries to true
        if (this.isNull(shouldTitleCase)) {
            shouldTitleCase = true;
        }
        if (this.isNull(shouldReplaceNonSpaceSep)) {
            shouldReplaceNonSpaceSep = true;
        }
        if (this.isNull(shouldReplaceHyphen)) {
            shouldReplaceHyphen = false;
        }

        if (this.isNull(ipStr) || typeof (ipStr) !== "string") {
            return ipStr
        }

        var modifiedStr = ipStr.trim()
        if (modifiedStr === "") {
            return "";
        }
        if (shouldReplaceNonSpaceSep === true) {
            modifiedStr = modifiedStr.replace(/[_]/g, " ")
        }
        if (shouldReplaceHyphen === true) {
            modifiedStr = modifiedStr.replace(/-/g, " ")
        }
        if (shouldTitleCase === true) {
            modifiedStr = modifiedStr.replace(/(^|\s)[a-zA-Z]/g, function (match) {
                if (match.length === 2) {
                    return match.charAt(0) + match.charAt(1).toUpperCase();
                }
                return match.toUpperCase();
            })
        }
        return modifiedStr;
    }

    static updateBodyBackgroundImage(bgImg, format, animation = false) {
        var bgVal = null;
        if (bgImg !== null && typeof (bgImg) === "string") {
            bgVal = "url(image/" + bgImg + "." + format + ")";
        }
        document.body.style.backgroundImage = bgVal;
        document.body.style.backgroundPosition = "center top";
        // document.body.style.backgroundSize = "cover";
        document.body.style.fontFamily = 'proxima_nova_rgregular';
    }

    static getTimestampSecs() {
        return Math.floor(Date.now() / 1000)
    }

    static getAndroidVersion() {
        var ua = navigator.userAgent.toLowerCase();
        var match = ua.match(/android\s([0-9.]+)/);
        if (this.isNull(match) === true || match.length < 2) {
            console.log("Not android")
            return false;
        }
        console.log("ANDROID-STR - " + match[1])
        return match[1]
    };

    static isDay() {
        /*
        If the time is >= 6 pm, it's night
        If the time is >= 6 am, it's day
        */
        var currHours = (new Date()).getHours()
        console.log("Curr hour -[0-23] -", currHours)
        return currHours >= 6 && currHours < 18
    }

    static formatLatLon(lat, lon) {
        if (this.isEmptyStr(lat) || this.isEmptyStr(lon)) {
            return null;
        }

        var latStr = this.formatFloatStrToFixed(lat, 2)
        var lonStr = this.formatFloatStrToFixed(lon, 2)
        if (Utils.isEmptyStr(latStr) || Utils.isEmptyStr(lonStr)) {
            return null;
        }
        // Make sure that if the last 2 entries are 00 then remove them
        if (false === Utils.isNull(latStr.match(/^-?\d+\.00$/))) {
            latStr = latStr.replace(/\.00$/, '')
        }
        if (false === Utils.isNull(lonStr.match(/^-?\d+\.00$/))) {
            lonStr = lonStr.replace(/\.00$/, '')
        }

        // Reference - https://stackoverflow.com/questions/4536996/positive-negative-latitude-and-longitude-values-vs-cardinal-directions
        // Positive latitude is above the equator (N), and negative latitude is below the equator (S).
        var latDir = "N"
        if (lat[0] === "-") {
            latDir = "S"
        }

        // Positive longitude is east of the prime meridian, while negative longitude is west of the prime meridian (
        var lonDir = "E"
        if (lon[0] === "-") {
            lonDir = "W"
        }

        // Not using ES 6 format strings since not really sure about the support
        return latStr + "° " + latDir + ", " + lonStr + "° " + lonDir
    }

    static formatFloatStrToFixed(fStr, precision) {
        if (Utils.isNull(fStr) || Utils.isNull(precision)) {
            return null
        }
        try {
            var fixedFStr = Math.abs(parseFloat(fStr)).toFixed(precision)
            // Remove the cases where .00 occurs
            if (false === Utils.isNull(fixedFStr.match(/^-?\d+\.00$/))) {
                fixedFStr = fixedFStr.replace(/\.00$/, '')
            }
            return fixedFStr
        } catch (e) {
            return null;
        }
    }

    /// Format city and the street entries. If both are null, then null is returned.
    /// If either is null, then it's set to empty string.
    /// This behaviour is for easily detecting when there is absolutely no data
    static formatArea(city, street) {
        var finalCity = null;
        if (false === this.isNull(city)) {
            var formattedCity = Utils.formatDisplayString(city, true, false)
            if (false === this.isNull(formattedCity) && formattedCity !== "") {
                finalCity = formattedCity;
            }
        }

        var finalStreet = null;
        if (false === this.isNull(street)) {
            var formattedStreet = Utils.formatDisplayString(street, true, false)
            if (false === this.isEmptyStr(formattedStreet)) {
                finalStreet = formattedStreet;
            }
        }

        if (this.isNull(finalCity) && this.isNull(finalStreet)) {
            return null
        } else if (this.isNull(finalCity)) {
            finalCity = "";
        } else if (this.isNull(finalStreet)) {
            finalStreet = "";
        }

        return {
            "area": finalStreet,
            "city": finalCity,
        }
    }

    // Copied from here - https://stackoverflow.com/a/2117523/1518924
    static generateUUID() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c === 'x' ? r : ((r & 0x3) | 0x8);
            return v.toString(16);
        });
    }

    static isWebView() {
        return (!Utils.isNull(navigator.userAgent) && navigator.userAgent.includes('wv'));
    }

    static getLatLonHash(lat, lon) {
        if (Utils.isNull(lat) || Utils.isNull(lon)) {
            return ""
        } else {
            return DEFAULT_REQ_PREFIX + lat + "_" + lon
        }
    }

}



// WEBPACK FOOTER //
// ./src/common/utils.js